import templateUrl from "./command-counsellor-groups-main.html";

export const commandCounsellorGroupsMainComponent = {
  templateUrl,
  bindings: {
    type: "@",
    title: "@",
    details: "<"
  },
  controller: class CommandCounsellorGroupsMainComponent {
    constructor($state, toastr, CommandCounsellorGroupsService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;

      this.CommandCounsellorGroupsService = CommandCounsellorGroupsService;
    }
    $onInit() {
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.getUnitIdentificationCodes();
      this.onChangeUIFcode();
      if (this.type === 'edit') {
        this.unitIdentificationCode = this.details.unitIdentificationCode;
      }
    }

    getUnitIdentificationCodes() {
      return this.CommandCounsellorGroupsService.getUnitIdentificationCodes().then((codes) => {
        this.uCodesList = codes;
        if(codes.length === 0){
          this.noUicCode = "No eligible UIC's are available";
          this.uCodesList.push(this.noUicCode)
        }
      })
    }
    goBack(){
      if(this.type === 'edit'){
      this.$state.go("commandCounsellorGroupsDetails",{group_id:this.details.groupId});
      }else{
        this.$state.go("commandCounsellorGroupsroute")
      }
    }
    onChangeUIFcode() {
      if (this.type === 'edit') {
        this.uifCode = this.details.unitIdentificationCode;
        this.isDisable = true;
        this.reqType = "updated";
      } else {
        this.uifCode = "Please Select";
        this.isDisable = false;
        this.reqType = "created";
      }
    }
    UICValidation(){
      if (this.details.unitIdentificationCode === "No eligible UIC's are available") {
        this.toastr.error("No eligible UIC's are available");
        this.isValidUic = false;
      }else if(this.details.unitIdentificationCode === null){
        this.toastr.error("Please Select Unit Identification Code");
        this.isValidUic = false;
      }else{
        this.isValidUic = true;
      }
    }
    onSubmit(){ 
      if (this.type === 'edit') {
        this.details.unitIdentificationCode = this.unitIdentificationCode;
      }
      this.UICValidation();
      if (this.isValidUic){
      this.CommandCounsellorGroupsService.updateGroup(this.details, this.type)
        .then((_) => {
          this.toastr.success(`Group ${this.reqType} Successfully.`);
          this.$state.go("commandCounsellorGroupsroute");
        })
        .catch((error) => {
          this.toastr.error(error.data.errors.message);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups-main/command-counsellor-groups-main.component.js